import { LineTypeCode, LineTypeName } from "@/types";
import { IBoardInfo, IBoardInfoData } from "./board.types";
import { IEarlyDriveData } from "../lineInfo";

export class BoardInfo implements IBoardInfo {
  id: string;
  lineTypeCode: LineTypeCode;
  lineTypeName: LineTypeName;
  lineRouteNo: string;
  lineRouteName: string;
  lineTurnUid: string;
  earlyDriveInfos: IEarlyDriveData[];
  carNo?: string;
  vendorName?: string;
  gateNo: string[];
  realGetOnBusStopUid: string;
  realGetOnBusStopName: string;
  realGetOnBusStopLat: number;
  realGetOnBusStopLng: number;
  realGetOnDateTime: string;
  isEvaluable: boolean;
  allocUid: string;
  campusName: string;
  firstStopTime: string;
  bookDateTime?: string;
  expectedGetOnBusStopUid?: string;
  expectedGetOnBusStopName?: string;
  getOnBusStopLat?: number;
  getOnBusStopLng?: number;
  expectedGetOffBusStopUid?: string;
  expectedGetOffBusStopName?: string;
  getOffBusStopLat?: number;
  getOffBusStopLng?: number;

  constructor(data: IBoardInfoData) {
    this.id = data.id;
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
    this.lineRouteNo = data.lineRouteNo;
    this.lineRouteName = data.lineRouteName;
    this.lineTurnUid = data.lineTurnUid;
    this.earlyDriveInfos = data.earlyDriveInfos;
    this.carNo = data.carNo;
    this.vendorName = data.vendorName;
    this.gateNo = data.gateNo;
    this.realGetOnBusStopUid = data.realGetOnBusStopUid;
    this.realGetOnBusStopName = data.realGetOnBusStopName;
    this.realGetOnBusStopLat = data.realGetOnBusStopLat;
    this.realGetOnBusStopLng = data.realGetOnBusStopLng;
    this.realGetOnDateTime = data.realGetOnDateTime;
    this.isEvaluable = data.isEvaluable;
    this.allocUid = data.allocUid;
    this.campusName = data.campusName;
    this.firstStopTime = data.firstStopTime;
    this.bookDateTime = data.bookDateTime;
    this.expectedGetOnBusStopUid = data.expectedGetOnBusStopUid;
    this.expectedGetOnBusStopName = data.expectedGetOnBusStopName;
    this.getOnBusStopLat = data.getOnBusStopLat;
    this.getOnBusStopLng = data.getOnBusStopLng;
    this.expectedGetOffBusStopUid = data.expectedGetOffBusStopUid;
    this.expectedGetOffBusStopName = data.expectedGetOffBusStopName;
    this.getOffBusStopLat = data.getOffBusStopLat;
    this.getOffBusStopLng = data.getOffBusStopLng;
  }

  validate(data: IBoardInfoData): void {
    if (!data.id) {
      throw new Error("Invalid board");
    }
  }
}
